// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".router{-webkit-transition:opacity .1s ease-in-out;transition:opacity .1s ease-in-out}.router.loading{opacity:.05}.mdi{display:inline!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
